import { render, staticRenderFns } from "./CommerceApprobeDetail.vue?vue&type=template&id=1e2771e6&scoped=true&"
import script from "./CommerceApprobeDetail.vue?vue&type=script&lang=ts&"
export * from "./CommerceApprobeDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CommerceApprobeDetail.vue?vue&type=style&index=0&id=1e2771e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2771e6",
  null
  
)

export default component.exports